export const getAuditControlsByCompanyNameQuery = (companyName: string) => {
    return {
        query: `
    query GetAuditControls($companyName: String!) {
        auditControlsByCompanyName(companyName: $companyName){
        id
        createdAt
        control {
          id
          objective {
            id
            name
            objectiveNumber
          }
          mainSystem {
            id
            isRequiredDaily
            system {
              id
              name
              abbreviation
            }
          }
          hrSystem {
            id
            isRequiredDaily
            system {
              id
              name
              abbreviation
            }
          }
          ticketSystem {
            id
            isRequiredDaily
            system {
              id
              name
              abbreviation
            }
          }
          companyControlId
          systemConsolidations
          isCreationEqualsOnboardingApproval
        }
        audit {
          id
          year
          entity {
            id
            name
          }
        }
        controlOwner {
          id
          firstName
          lastName
          email
        }
        controlIt {
          id
          firstName
          lastName
          email
        }
        isHidden
        isAutomated
        dashboardAdditionalInfo
        controlResultsAdditionalInfo
        status
      }
    }
    `,
        variables: { companyName }
    }
}

// Full query with all control details — used by the add/edit form and execution pipeline
export const getFullAuditControlsByCompanyNameQuery = (companyName: string) => {
    return `
    {
        auditControlsByCompanyName(companyName:"${companyName}"){
        id
        createdAt
        control {
          objective {
            id
            name
          }
          mainSystem {
            id
            isRequiredDaily
            system {
              id
              name
            }
            integrationType
          }
          hrSystem {
            id
            isRequiredDaily
            system {
              id
              name
            }
            integrationType
          }
          ticketSystem {
            id
            isRequiredDaily
            system {
              id
              name
            }
            integrationType
          }
          companyControlId
          systemConsolidations
          dashboardAdditionalInfo
          controlResultsAdditionalInfo
          consolidationConfig
          systemsArr
          isCreationEqualsOnboardingApproval
        }
        audit {
          id
          year
          entity {
            id
            name
          }
        }
        controlOwner {
          id
          firstName
          lastName
          email
        }
        isHidden
        isAutomated
        dashboardAdditionalInfo
        controlResultsAdditionalInfo
        status
        controlIt{
          id
          firstName
          lastName
          email
        }
      }
    }
    `
}
